import { AnimatePresence, motion } from 'framer-motion';
import classNames from 'classnames';
import Images from 'assets/Images';
import Button from '../button';
import './style.scss';

const SideDrawer = props => {
	const { children, drawerState, title, onClose, showSave } = props;
	return (
		<AnimatePresence>
			{drawerState && (
				<div className='side-drawer align-center'>
					<motion.div initial={{ opacity: 0 }} animate={{ opacity: 0.5 }} exit={{ opacity: 0 }} className={classNames({ 'side-drawer__backdrop': true })} onClick={() => onClose(false)}></motion.div>
					<motion.div initial={{ x: 100, opacity: 0 }} animate={{ x: 0, opacity: 1 }} exit={{ x: 100, opacity: 0 }} transition={{ duration: 0.3 }} className='side-drawer__content'>
						<h4 className='side-drawer__title space-between'>
							{title}
							{showSave && <div className='flex-end'>
								<Button height='35px' primary compact transparent xsmall label='Cancel' handleOnSubmit={() => onClose(false)} />
								<div className='side-drawer__saveButton'>
									<Button height='35px' primary xsmall label='Save' handleOnSubmit={() => onClose(true)} />
								</div>
							</div>}
							{!showSave && <img src={Images?.closeBlue} alt='Close' onClick={() => onClose(false)} />}
						</h4>
						{children}
					</motion.div>
				</div>
			)}
		</AnimatePresence>
	);
};

export default SideDrawer;
